import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12">
          <div>
            <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">
              —— 攻略资讯 ——
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              最新文章
            </h2>
          </div>
          <Link
            to="/category/all"
            className="mt-3 sm:mt-0 flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 font-bold mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}